// import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import roundSend from '@iconify/icons-ic/round-send';
import attach2Fill from '@iconify/icons-eva/attach-2-fill';
import roundAddPhotoAlternate from '@iconify/icons-ic/round-add-photo-alternate';
// material
import { styled } from '@material-ui/core/styles';
import { Input, Divider, IconButton, InputAdornment, Stack, Typography, Box, Paper, Chip } from '@material-ui/core';
//
import EmojiPicker from '../../EmojiPicker';
// import UploadContact from '../../../pages/dashboard/contact/ListSidebar/uploadContacrt';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import useAuth from '../../../hooks/useAuth';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  maxHeight: 110,
  minHeight: 60,
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(2)
}));

// ----------------------------------------------------------------------

ChatMessageInput.propTypes = {
  disabled: PropTypes.bool,
  sendToId: PropTypes.string,
  onSend: PropTypes.func
};

export default function ChatMessageInput({ oa_id, app_id, user_id,conversation_id,chat_mode, disabled, sendToId, onSend, ...other }) {
  const fileInputRef = useRef(null);
  const [message, setMessage] = useState('');
  const [isShowTempFile, setIsShowTempFile] = useState(false);
  const [updateLoadFile, setUpLoadFile] = useState(false);
  const [refValue, setRefValue] = useState([]);
  const { user } = useAuth();
  const handleAttach = () => {
    fileInputRef.current.click();
    setUpLoadFile(true);
  };

  const handleChangeMessage = (event) => {
    setMessage(event.target.value);
  };

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      handleSend();
    }
  };

  const handleSend = () => {
    if (!message && fileInputRef.current?.files.length === 0) {
      return '';
    }
    if (onSend) {
      const params_send = {
        oa_id,
        app_id,
        user_id,
        conversation_id,
        chat_mode,  
        contentType: 'text',
        attachments: [],
        message:"",
        user_response: user?.id
      }
      if (refValue.length > 0) {
        for (var j = 0; j < refValue.length; j++) {
          params_send.attachments = refValue[j];
          params_send.contentType = "file";
          onSend(params_send);
        }
      }
      if (message) {
        params_send.attachments = [];
        params_send.message = message;
        params_send.contentType = 'text';
        onSend(params_send);
      }
      setRefValue([]);
      setIsShowTempFile(false);
      fileInputRef.current.value = "";
      setUpLoadFile(false)
    }
    return setMessage('');
  };
  // const onHandleShowFileTemp = () => {
  //   if (fileInputRef.current.files.length > 0) {
  //     setIsShowTempFile(true)
  //   } else {
  //     setIsShowTempFile(false)
  //   }

  // }
  const onHandleShowFileTemp = () => {
    if (fileInputRef.current.files.length > 0) {
      setRefValue(fileInputRef.current.files)
      setIsShowTempFile(true)
    } else {
      setIsShowTempFile(false);
      setRefValue([])
    }

  }
  const onDeleteFile = (index) => {
    if (refValue) {
      if (refValue.length == 1) {
        setIsShowTempFile(false);
        setRefValue([]);
        fileInputRef.current.value = "";
      } else {
        const newListFiles = Array.from(refValue).filter((file_current, i) => i != index);
        const dataTransfer = new DataTransfer();
        newListFiles.forEach(file => {
          dataTransfer.items.add(file);
        });
        setRefValue(dataTransfer.files)
      }
    }
  }
  return (
    <RootStyle {...other}>
      <Stack width={"100%"} direction={"column"} spacing={1}>
        {isShowTempFile ? <Stack width={"100%"} direction={"row"} spacing={1}>
          {refValue?.length > 0 && Array.from(refValue).map((file, index) => {
            return (
              <Box key={index} component={Paper} display={"flex"} flexDirection={"column"} maxWidth={200} maxHeight={50}>
                <Chip avatar={<AttachFileIcon />} label={file.name} onDelete={() => onDeleteFile(index)}>  </Chip>
              </Box>
            )
          })}

        </Stack> : null}
        <Stack width={"100%"} direction={"row"}>
          <Input
            disabled={disabled}
            fullWidth
            value={message}
            disableUnderline
            onKeyUp={handleKeyUp}
            onChange={handleChangeMessage}
            placeholder="Type a message"
            startAdornment={
              <InputAdornment position="start">
                <EmojiPicker disabled={disabled} value={message} setValue={setMessage} />
              </InputAdornment>
            }
            endAdornment={
              <Stack direction="row" spacing={0.5} mr={1.5}>
                <IconButton disabled={disabled} size="small" onClick={handleAttach}>
                  <Icon icon={roundAddPhotoAlternate} width={24} height={24} />
                </IconButton>
                <IconButton disabled={disabled} size="small" onClick={handleAttach}>
                  <Icon icon={attach2Fill} width={24} height={24} />

                </IconButton>
                {/* <IconButton disabled={disabled} size="small">
              <Icon icon={micFill} width={24} height={24} />
            </IconButton> */}
              </Stack>
            }
            sx={{ height: '100%' }}
          />

          <Divider orientation="vertical" flexItem />

          <IconButton color="primary" disabled={message != "" || updateLoadFile ? false : true} onClick={handleSend} sx={{ mx: 1 }}>
            <Icon icon={roundSend} width={24} height={24} />
          </IconButton>
          {/* {(updateLoadFile && fileInputRef.current.files.length > 0) &&
            <>
              <Typography>File ne</Typography>
              <img style={{ width: 60, height: 60 }} src={URL.createObjectURL(fileInputRef.current.files[0])} />
            </>

          } */}
          <input multiple type="file" ref={fileInputRef} onChange={() => onHandleShowFileTemp()} style={{ display: 'none' }} />
        </Stack>
      </Stack>


    </RootStyle>
  );
}
